$(function() {
    $(window).on("load", function() {
        if ($("#preSuccess").attr("data-success") != "") {
            $("#success-modal").css("display", "block");

            $("#closeImg").on("click", function() {
                $("#success-modal").addClass("fadeOut");
                setTimeout(() => {
                    $("#success-modal").css("display", "none");
                }, 250);
            });
            if ($("#success-modal").length > 0) {
                $([document.documentElement, document.body]).animate(
                    {
                        scrollTop: $("#success-modal").offset().top - 100
                    },
                    1000
                );
            }
        }
        $("#show-gdpr").on("click", function() {
            $("#arrow-gdpr").toggleClass("rotate-180");
            $("#more-gdpr").slideToggle();
        });
    });
});
